import { render, staticRenderFns } from "./demoAccountManagement.vue?vue&type=template&id=48ed0d41&scoped=true"
import script from "./demoAccountManagement.vue?vue&type=script&lang=js"
export * from "./demoAccountManagement.vue?vue&type=script&lang=js"
import style0 from "./demoAccountManagement.vue?vue&type=style&index=0&id=48ed0d41&prod&lang=scss"
import style1 from "./demoAccountManagement.vue?vue&type=style&index=1&id=48ed0d41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed0d41",
  null
  
)

export default component.exports